import { forwardRef, ImgProps, Img } from "@chakra-ui/react";

export const Image = forwardRef<ImgProps, "img">((props, ref) => (
  <Img
    style={{ imageRendering: "-webkit-optimize-contrast" }}
    ref={ref}
    {...props}
  />
));
